module.exports = __webpack_public_path__ + "static/media/info.2918c3e5.svg";